import React from "react";
import styled from "astroturf";

import skylogo from "../../assets/img/icons/sky.svg";

export const SkImg = styled("img")`
  width: 116px;
  height: 34px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export const ImgWrapper = styled("div")`
  width: 116px;
  height: 22px;
  position: relative;
`;

export const Sk = () => (
  <ImgWrapper>
    <SkImg src={skylogo} alt="sky-logo" />
  </ImgWrapper>
);
